/**
 * External dependencies
 */
import { IconListIcon } from '~cartzillagb/icons'
import {
	disabledBlocks,
	i18n,
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'


/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'


export const schema = {
	blockId: {
		type: 'string',
		default: '',
	},

	enableContainer: {
		type: 'boolean',
		default: true,
	},

	title: {
		type: 'string',
		default: __( "Seller of the month", i18n ),
	},

	users: {
		type: 'array',
		default: [],
	},

	design: {
		type: 'string',
		default: 'style-v2',
	},

	limit: {
		type: 'number',
		default: 3,
	},

	orderby: {
		type: 'string',
		default: 'date',
	},

	order: {
		type: 'string',
		default: 'DESC',
	},

	// Carousel Options
	slidesToShow: {
		type: 'number',
		default: 3,
	},

	slidesToShowLaptop: {
		type: 'number',
		default: 3,
	},

	slidesToShowTablet: {
		type: 'number',
		default: 3,
	},

	slidesToShowMobile: {
		type: 'number',
		default: 1,
	},

	dots: {
		type: 'boolean',
		default: true,
	},

	arrows: {
		type: 'boolean',
		default: false,
	},
}

export const name = 'czgb/seller-block'

export const settings = {
	title: __( 'Seller Block', i18n ),
	icon: IconListIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	// modules: {
	// 	'advanced-responsive': true,
	// },
}